import { z } from 'zod';

export const CheckoutRequestSchema = z.object({
  amount: z.number().positive(),
  currency: z.enum(['USD', 'CAD']),
});

export const CheckoutResponseSchema = z.object({
  secretToken: z.string(),
  checkoutToken: z.string(),
});

export const HelcimTransactionResponseSchema = z.object({
  transactionId: z.string(),
  dateCreated: z.string(),
  cardBatchId: z.string(),
  status: z.string(),
  type: z.string(),
  amount: z.string(),
  currency: z.string(),
  avsResponse: z.string(),
  cvvResponse: z.string(),
  approvalCode: z.string(),
  cardToken: z.string(),
  cardNumber: z.string(),
  cardHolderName: z.string(),
  customerCode: z.string(),
  invoiceNumber: z.string(),
  warning: z.string(),
});

export const HelcimPayResponseSchema = z.object({
  data: HelcimTransactionResponseSchema,
  hash: z.string(),
});

export const PaymentConfirmRequestSchema = z.object({
  invoiceId: z.number().positive(),
  responseData: z.string(),
  responseHash: z.string(),
  secretToken: z.string(),
});

export const HelcimPayConfigSchema = z.object({
  onSuccess: z.function().args(HelcimPayResponseSchema).returns(z.void()),
  onError: z.function().args(z.unknown()).returns(z.void()),
  onCancel: z.function().args().returns(z.void()).optional(),
});

export const PaymentHistorySchema = z.object({
  id: z.number(),
  invoiceId: z.number(),
  amount: z.number(),
  currency: z.enum(['USD', 'CAD']),
  invoiceNumber: z.string(),
  quickbooksId: z.string(),
  dateModified: z.string(),
});

export const PaymentHistoryResponseSchema = z.array(PaymentHistorySchema);

export type PaymentHistoryResponse = z.infer<
  typeof PaymentHistoryResponseSchema
>;
export type PaymentHistory = z.infer<typeof PaymentHistorySchema>;
export type CheckoutRequest = z.infer<typeof CheckoutRequestSchema>;
export type CheckoutResponse = z.infer<typeof CheckoutResponseSchema>;
export type HelcimTransactionResponse = z.infer<
  typeof HelcimTransactionResponseSchema
>;
export type HelcimPayResponse = z.infer<typeof HelcimPayResponseSchema>;
export type PaymentConfirmRequest = z.infer<typeof PaymentConfirmRequestSchema>;
export type HelcimPayConfig = z.infer<typeof HelcimPayConfigSchema>;

declare global {
  interface Window {
    appendHelcimPayIframe?: (token: string, allowExit?: boolean) => void;
  }
}
